<template>
  <div>
    <div class="row mx-4">
      <div class="col-xs-12">
        <h4 style="color:#2E7D32;">
          {{ form.export_order_id ? `Update Export Order ${form.order_number}` : 'Request Export Order' }}
        </h4>
      </div>
    </div>

    <div
      class="col-md-12"
      style="border-bottom-style: solid; border-width: 2px; border-color: #388E3C"
    />

    <form @submit.prevent="submitForm()">
      <v-alert
        type="success"
        :value="checkAlert"
      >
        Requested successfully
      </v-alert>

      <div class="row mx-4">
        <div class="col-md-12">
          <v-text-field
            label="Product Description*"
            v-model="form.product_name"
            :error-messages="errors.collect('Product Description')"
            v-validate="'required'"
            data-vv-name="Product Description"
          />
        </div>

        <div class="col-md-6">
          <v-text-field
            label="Quantity*"
            v-model="form.quantity"
            :error-messages="errors.collect('Quantity')"
            v-validate="'required|numeric|min_value:1'"
            data-vv-name="Quantity"
          />
        </div>

        <div class="col-md-5">
          <v-text-field
            label="Weight"
            v-model="form.weight"
          />
        </div>
        <div class="col-xs-1">
          <v-select
            :items="weightUnitList"
            v-model="form.weight_unit"
            :error-messages="errors.collect('Weight Unit')"
            data-vv-name="Weight Unit"
            v-validate="'required'"
            autocomplete
          />
        </div>

        <div class="col-xs-12">Dimensions Per Package <span class="inch-div">(inch)</span></div>
        <div class="col-xs-3">
          <v-text-field
            v-model="form.size_l"
            label="Length"
            type="number"
          />
        </div>
        <div class="col-xs-3">
          <v-text-field
            v-model="form.size_w"
            label="Width"
            type="number"
          />
        </div>
        <div class="col-xs-3">
          <v-text-field
            v-model="form.size_h"
            label="Height"
            type="number"
          />
        </div>
        <div class="col-xs-3">
          <input
            type="file"
            accept="image/*"
            name="image"
            id="image"
            style="display: none"
            @input="form.image = $event.target.files[0]"
          >
          <label
            for="image"
            class="btn btn-primary"
          >
            <i class="fa fa-upload"></i> Upload Image
            <i class="pl-1">{{ form.image ? form.image.name : '' }}</i>
          </label>
        </div>
      </div>

      <v-divider></v-divider>

      <div class="row mx-4">
        <div class="col-xs-12">
          <div style="font-size: 16px">Receiver Detail</div>
        </div>

        <div class="col-md-6">
          <v-text-field
            label="Name*"
            v-model="form.receiver_name"
            :error-messages="errors.collect('Name')"
            v-validate="'required'"
            data-vv-name="Name"
          />
        </div>

        <div class="col-md-6">
          <v-text-field
            label="Phone*"
            v-model="form.receiver_phone"
            :error-messages="errors.collect('Phone')"
            v-validate="'required'"
            data-vv-name="Phone"
          />
        </div>

        <div class="col-md-6">
          <v-text-field
            label="Address*"
            v-model="form.receiver_address"
            :error-messages="errors.collect('Address')"
            v-validate="'required'"
            data-vv-name="Address"
          />
        </div>

        <div class="col-md-6">
          <v-text-field
            label="City*"
            v-model="form.receiver_city"
            :error-messages="errors.collect('City')"
            v-validate="'required'"
            data-vv-name="City"
          />
        </div>

        <div class="col-md-6">
          <v-text-field
            label="Zip Code*"
            v-model="form.receiver_zip_code"
            :error-messages="errors.collect('Zip Code')"
            v-validate="'required'"
            data-vv-name="Zip Code"
          />
        </div>

        <div class="col-md-6">
          <v-select
            autocomplete
            :items="countryList"
            item-value="value"
            v-model="form.to_country_id_fk"
            :error-messages="errors.collect('Destination')"
            data-vv-name="Destination"
            label="Destination*"
            v-validate="'required'"
          />
        </div>

        <div class="col-md-6">
          <v-text-field
            label="Email*"
            type="email"
            v-model="form.receiver_email"
          />
        </div>
      </div>

      <v-spacer></v-spacer>

      <div class="col-sm-10 col-md-6 col-md-offset-3">
        <v-btn
          type="submit"
          :loading="loading"
          style="width: 100%; height:auto; margin-bottom: 3%"
          color="success"
        >
          {{ form.export_order_id ? 'Update' : 'Request' }}
        </v-btn>
      </div>
    </form>
  </div>
</template>
<script>
import axios from 'axios'
import swal from 'sweetalert'

export default {

  mounted() {
    this.getCountryList()

    // if edit mode get order data
    if (this.$route.params.id) {
      this.getOrder()
    }
  },

  $_veeValidate: {
    validator: 'new'
  },

  data() {
    return {
      weightUnitList: [
        { text: 'KG', value: 'kg' },
        { text: 'LB', value: 'lb' }
      ],
      countryList: [],
      checkAlert: false,
      loading: false,
      form: {
        product_name: null,
        quantity: null,
        weight: null,
        image: null,
        weight_unit: 'kg',
        size_l: null,
        size_w: null,
        size_h: null,
        receiver_name: null,
        receiver_phone: null,
        receiver_address: null,
        receiver_city: null,
        receiver_zip_code: null,
        to_country_id_fk: null,
        receiver_email: null
      }
    }
  },

  methods: {
    getCountryList() {
      let token = localStorage.getItem('access_token')
      axios
        .get('api/country/list', { headers: { Authorization: 'Bearer ' + token } })
        .then((response) => {
          this.countryList = response.data.map((item) => {
            return { text: item.country_name, value: item.country_id }
          })
        })
    },

    getOrder() {
      let token = localStorage.getItem('access_token')
      axios
        .get(`api/customer_order_detail/${this.$route.params.id}`, { headers: { Authorization: 'Bearer ' + token } })
        .then(response => {
          this.form = response.data.data[0]
        })
    },

    submitForm() {
      this.$validator.validateAll().then(res => {
        if (res) {
          this.loading = true
          let token = localStorage.getItem('access_token')

          let formData = new FormData()
          for (let key in this.form) {
            if (this.form[key]) {
              formData.append(key, this.form[key])
            }
          }

          if (this.form.export_order_id) {
            axios
              .put(`api/update-order-by-customer/${this.form.export_order_id}`, this.form, {
                headers: { Authorization: 'Bearer ' + token }
              })
              .then(() => {
                this.loading = false
                this.checkAlert = true
                setTimeout(() => {
                  this.checkAlert = false
                  this.clearForm()
                  this.$router.push('/my-export-order')
                }, 2000)
              })
              .catch(error => {
                this.loading = false
                this.checkAlert = false
                swal('Error', `${error.response.data.message}`, 'error')
              })
          } else {
            axios
              .post('api/export-order', formData, { headers: { Authorization: 'Bearer ' + token } })
              .then(() => {
                this.loading = false
                this.checkAlert = true
                this.clearForm()
                setTimeout(() => {
                  this.checkAlert = false
                }, 2000)
              })
              .catch(error => {
                this.loading = false
                this.checkAlert = false
                swal('Error', `${error.response.data.message}`, 'error')
              })
          }
        }
      })
    },

    clearForm() {
      this.form = {
        product_name: null,
        quantity: null,
        weight: null,
        weight_unit: 'kg',
        size_l: null,
        size_w: null,
        size_h: null,
        image: null,
        receiver_name: null,
        receiver_phone: null,
        receiver_address: null,
        receiver_city: null,
        receiver_zip_code: null,
        to_country_id_fk: null,
        receiver_email: null
      }

      this.$validator.reset()
    }
  }
}
</script>

<style scoped>
.panel-heading {
  color: #006b8d;
  border-bottom: 2px solid #006b8d !important;
}

.panel-heading h4 {
  text-transform: uppercase;
  margin-left: -20px;
  padding-left: 10px;
  font-weight: 500;
}

.panel-flat {
  overflow-x: hidden !important;
}
</style>



// WEBPACK FOOTER //
// src/components/customer/exportOrder/addExportOrder.vue